/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosSearchAgentHandlerInfo } from '../models/AptosSearchAgentHandlerInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosExternalControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns AptosSearchAgentHandlerInfo OK
     * @throws ApiError
     */
    public getAptosSearchHandlerForAgent({
        term,
        filtersBy,
    }: {
        term: string,
        filtersBy?: Array<'ALL' | 'BLOCK' | 'TRANSACTION' | 'ADDRESS' | 'TOKEN' | 'MODULE' | 'COIN' | 'FUNGIBLE_ASSET' | 'COLLECTION' | 'OBJECT' | 'BATCH_TRX'>,
    }): CancelablePromise<AptosSearchAgentHandlerInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/external/search/handler',
            query: {
                'filtersBy': filtersBy,
                'term': term,
            },
        });
    }

}
